import React from "react";
import TermsAndConditions from "../components/otherPageComponent/TermsandConditions";
import SEO from "../components/SEO";

function TermsAndConditionsPage() {
  return (
    <>
      <SEO
        title="Terms & Conditions - Aastha Computers"
        description="Review the Terms and Conditions for using Aastha Computes’ website and services. Understand your rights, responsibilities, and our policies."
        pagePath="/terms-and-conditions"
      />
      <TermsAndConditions />
    </>
  );
}

export default TermsAndConditionsPage;
